const baseURL = process.env.REACT_APP_BASE_URL;

const socketURL = process.env.REACT_APP_SOCKET_URL;

const PricingFlag = process.env.REACT_APP_PRICING_FLAG === "true";

export { baseURL, socketURL , PricingFlag };
